import { AxiosResponse } from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
export const LocalDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?$/;
export const IsoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;
export const convertDateTimeStringToObject = (dateFormat: RegExp) => (resp: AxiosResponse<any, any>) => {
    if (resp && resp.data) {
        convertDateTimesRecursively(resp.data, dateFormat);
    }
    return resp;
};

function convertDateTimesRecursively(data: any, format: RegExp) {
    if (data && typeof data === "string" && data.length >= 10) {
        if (format.test(data)) {
            data = dayjs(data).toDate();
            return;
        }
    }
    if (!data || typeof data !== "object") {
        return;
    }
    for (const key of Object.keys(data)) {
        const value = data[key];
        if (typeof value === "string" && value.length >= 10) {
            if (format.test(value)) {
                const convertedDate = dayjs(value).toDate();
                data[key] = convertedDate;
            }
        } else if (typeof value === "object") {
            convertDateTimesRecursively(value, format);
        }
    }
}
